import { Box, LoadingBar } from '@components/gassan-ui'
import { FC } from 'react'
import styled from 'styled-components'

const ImageLoading = styled(LoadingBar)<Props>`
  width: 100%;
  height: auto;

  &::before {
    padding-top: ${(p) => (p.isRegular ? '55%' : '45%')};
    content: '';
    display: block;
    width: 100%;
  }
`

type Props = {
  isRegular: boolean
}

const Loading: FC<Props> = ({ isRegular }) => {
  return (
    <>
      <Box mb="1.5rem">
        <ImageLoading isRegular={isRegular} />
      </Box>
      <Box>
        <LoadingBar height="2rem" mb="1.25rem" />
        <LoadingBar height="1.5rem" mb="0rem" width="10rem" />
      </Box>
    </>
  )
}

export default Loading
